import { translate } from '@vimeo/i18n-runtime';

export const T = {
  daily: translate('Daily'),
  notStartedYet: translate('This live event has not started yet'),
  scheduled: translate('Scheduled'),
  schedulePlaceholder: translate("This event hasn't started yet"),
  watchLive: translate('Watch live'),
  weekdays: translate('Weekdays'),
  weekends: translate('Weekends'),
};
